var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.59819 2.18536L16.7613 14.3518L4.5995 26.5187C4.36891 26.4212 4.16693 26.2507 4.03183 26.0174C3.92654 25.8355 3.87109 25.6291 3.87109 25.4189V3.28491C3.87109 2.79109 4.17077 2.36726 4.59819 2.18536Z",
    fill: "#00CAEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6058 15.1963L20.3554 17.9458L7.29192 25.5101L17.6058 15.1963Z",
    fill: "#E24043"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29192 3.19346L20.3566 10.7565L17.6058 13.5074L7.29192 3.19346Z",
    fill: "#09E876"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4268 11.3765L24.7796 13.3183C25.3506 13.6488 25.5455 14.3795 25.2149 14.9503C25.1104 15.1309 24.9603 15.2811 24.7796 15.3856L21.4256 17.3271L18.4503 14.3518L21.4268 11.3765Z",
    fill: "#F6BE06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.663807ac4697b8d6b2e3b23dc2076e74.svg";
export { ForwardRef as ReactComponent };